import { render, staticRenderFns } from "./NoticiasComponent.vue?vue&type=template&id=2e758069&scoped=true&"
import script from "./NoticiasComponent.vue?vue&type=script&lang=ts&"
export * from "./NoticiasComponent.vue?vue&type=script&lang=ts&"
import style0 from "./NoticiasComponent.vue?vue&type=style&index=0&id=2e758069&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e758069",
  null
  
)

export default component.exports